import { useEffect, useState } from "react";
import bilAPI from "../../services/api";
import TokenService from "../../services/token.service";

export default function useFindUser() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = TokenService.getLocalAccessToken();
    if (!token) {
      setIsLoading(false);
      return;
    }

    bilAPI
      .get("/auth/me/")
      .then((res) => setUser(res.data))
      .catch(() => TokenService.removeTokens())
      .finally(() => setIsLoading(false));
  }, []);

  return { user, setUser, isLoading };
}
